// 兼容层：仅供 Reimbursement 目录下的历史备份页面（Reimbursement copy*.vue）引用。
// 这些备份页面以 printmb(row) 形式调用，row 为报销单数据，打印个人费用报销单。
import printmb2 from "../mb/2";

export default function(row) {
  printmb2(row);
}
